export const padreState = {
    id: '',
    id_veeduria: '',
    tipo_doc_padre: '',
    dni: '',
    nombre: '',
    apellido_paterno: '',
    apellido_materno: '',
    nombre_completo: '',
    celular: '',
    existe: false,
    fecha_emision: null,
    codigo_verificacion: '',
    isLoading: false,
    isValidated: false,
    message: '',
    severity: '',
    token: '',
}